module.exports = "/images/vendor/flag-icon-css/flags/4x3/al.svg?4eb491e7412fcc678a29741fdc941eba";